import { createContext, useState } from 'react';

interface ITableRefreshProvider {
  children: React.ReactNode;
}

interface ITableRefreshContext {
  setRefreshTable: (...args: any) => void;
  refreshTable: boolean;
}

export const TableRefreshContext = createContext<ITableRefreshContext | null>(
  null
);

export const TableRefreshProvider: React.FC<ITableRefreshProvider> = ({
  children,
}) => {
  const [refreshTable, setRefreshTable] = useState(true);

  return (
    <TableRefreshContext.Provider
      value={{
        refreshTable,
        setRefreshTable,
      }}
    >
      {children}
    </TableRefreshContext.Provider>
  );
};
